<script setup lang="ts">
    import MainMenu from '@/components/MainMenu.vue';
    import CanvasContainer from '@/components/CanvasContainer.vue';
    import useConfigStore from '@/store/config.store';
    import { EAppStep } from '@/typescript/enums/EAppStep';
    import { computed, type PropType } from 'vue';
    import { storeToRefs } from 'pinia';
    import type { ITextField } from '@/typescript/interfaces/ITextField';
    import type { IImageField } from '@/typescript/interfaces/IImageField';
    import type { MeshStandardMaterial } from 'three';

    const { currentStep } = storeToRefs(useConfigStore());

    const showPreview = computed(() => currentStep.value === EAppStep.PREVIEW);
    defineProps({
        updateCustomMaterial: {
            type: Function as PropType<(fields: ITextField[] | IImageField[], getImage: boolean) => Promise<void>>,
            required: true,
        },
        customMaterial: {
            type: Object as PropType<MeshStandardMaterial>,
            required: true,
        },
    });
</script>

<template>
    <div class="relative h-full w-full">
        <CanvasContainer
            v-show="showPreview"
            :update-custom-material
            :custom-material
            :show-preview
            class="absolute z-10 h-full w-full"
        />
        <MainMenu class="w-full" />
    </div>
</template>
